import {
  image,
  changeZoom,
  stopAutorotation,
  isSmothZoom
} from "./variable";

let interval;
let zoomScale = 1;

export const getZoomScale = () => zoomScale;

export const zoom = (option) => {
  if (isSmothZoom) {
    switch (option) {
      case "in":
        if (zoomScale <= 2) {
          zoomScale *= 1.2;
          image.style.transform = `scale(${zoomScale})`;
        }
        break;
      case "out":
        if (zoomScale > 1) {
          zoomScale = zoomScale / 1.2;
          image.style.transform = `scale(${zoomScale})`;
        }
        if (zoomScale / 1.2) {
          setTimeout(() => changeZoom(false), 200);
        }
        break;
    }
  }
};

export const zoomStart = (option) => {
  if (isSmothZoom) {
    changeZoom(true);
    stopAutorotation();
    zoom(option);
    if (!interval) {
      interval = setInterval(() => {
        zoom(option);
      }, 200);
    }
  }
};

export const zoomStop = () => {
  if (isSmothZoom) {
    if (interval) {
      clearInterval(interval);
      interval = null;
    }
  }
};